exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  --primary: #013188;\n  --primary-darker: #002d72;\n  --secondary: #ff720a;\n  --secondary-darker: #dd5f13;\n  --button-text: #fefefe;\n  --disabled: #c2c2c2;\n  --button-text-disabled: rgba(0,0,0,0.38);\n  --bg-auth: url(" + require("assets/imgs/login/bg.jpg") + ");\n  --logo-auth: none;\n  --logo-header: none;\n  --favicon: none;\n}\n.app-limits-faq .card {\n  margin: 30px 0;\n  min-width: 300px;\n  max-width: 525px;\n}\n.app-limits-faq .footer {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: space-evenly;\n      -ms-flex-pack: space-evenly;\n          justify-content: space-evenly;\n  padding: 40px 0 16px 0;\n}\n.app-limits-faq .footer button {\n  border: 2px solid #e95814;\n  border-radius: 8px;\n  padding: 8px 14px;\n  background-color: #e95814;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 16px;\n  color: #fff;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/limits/faq/faq.component.styl
// module id = ../../../../../src/app/master/limits/faq/faq.component.styl
// module chunks = main